export const DEFAULT_SEARCH_PAGINATION = {
  page: 1,
  itemsPerPage: 20,
};
